<template>
  <div class="container py-5 mx-auto md-layout">
    <div class="mx-auto md-layout-item md-small-size-100 md-size-60">
      <a href="/legal/privacy">&larr; Back to Privacy Portal</a>
    </div>
    <div class="mx-auto md-layout-item md-small-size-100 md-size-60">
      <h1>Terms of Use</h1>

      <h2>Welcome to ArtistHub!</h2>

      <p>Last Updated: November 8, 2023</p>
      
      <p>
        These terms and conditions outline the rules and regulations for the use
        of Artist Hub Inc's websites, APIs, mobile applications and services.
      </p>

      <p>
        By accessing this website we assume you accept these terms and
        conditions. Do not continue to use ArtistHub if you do not agree to take
        all of the terms and conditions stated on this page.
      </p>

      <p>
        The following terminology applies to these Terms and Conditions, Privacy
        Statement and Disclaimer Notice and all Agreements: "Client", "You" and
        "Your" refers to you, the person log on this website and compliant to
        the Company’s terms and conditions. "The Company", "Ourselves", "We",
        "Our" and "Us", refers to our Company. "Party", "Parties", or "Us",
        refers to both the Client and ourselves. All terms refer to the offer,
        acceptance and consideration of payment necessary to undertake the
        process of our assistance to the Client in the most appropriate manner
        for the express purpose of meeting the Client’s needs in respect of
        provision of the Company’s stated services, in accordance with and
        subject to, prevailing law of the State of Florida. Any use of the above
        terminology or other words in the singular, plural, capitalization
        and/or he/she or they, are taken as interchangeable and therefore as
        referring to same.
      </p>

      <h2>Cookies</h2>

      <p>
        We employ the use of cookies. By accessing ArtistHub, you agreed to use
        cookies in agreement with the Artist Hub Inc.'s Privacy Policy.
      </p>

      <p>
        Most interactive websites use cookies to let us retrieve the user’s
        details for each visit. Cookies are used by our website to enable the
        functionality of certain areas to make it easier for people visiting our
        website. Some of our affiliate/advertising partners may also use
        cookies.
      </p>

      <h2>License</h2>

      <p>
        Unless otherwise stated, Artist Hub Inc. and/or its licensors own the
        intellectual property rights for all material on ArtistHub. All
        intellectual property rights are reserved. You may access this from
        ArtistHub for your own personal use subjected to restrictions set in
        these terms and conditions.
      </p>

      <p>You must not:</p>
      <ul>
        <li>Republish material from ArtistHub</li>
        <li>Sell, rent or sub-license material from ArtistHub</li>
        <li>Reproduce, duplicate or copy material from ArtistHub</li>
        <li>Redistribute content from ArtistHub</li>
        <li>Reverse engineer or attempt to reverse engineer any software contained on ArtistHub</li>
      </ul>

      <p>
        This Agreement shall begin on the date hereof.
      </p>

      <p>
        Parts of this website offer an opportunity for users to post and
        exchange opinions and information in certain areas of the website.
        Artist Hub Inc. does not filter, edit, publish or review Comments prior
        to their presence on the website. Comments do not reflect the views and
        opinions of Artist Hub Inc.,its agents and/or affiliates. Comments
        reflect the views and opinions of the person who post their views and
        opinions. To the extent permitted by applicable laws, Artist Hub Inc.
        shall not be liable for the Comments or for any liability, damages or
        expenses caused and/or suffered as a result of any use of and/or posting
        of and/or appearance of the Comments on this website.
      </p>

      <p>
        Artist Hub Inc. reserves the right to monitor all Comments and to remove
        any Comments which can be considered inappropriate, offensive or causes
        breach of these Terms and Conditions.
      </p>

      <p>You warrant and represent that:</p>

      <ul>
        <li>
          You are entitled to post the Comments on our website and have all
          necessary licenses and consents to do so;
        </li>
        <li>
          The Comments do not invade any intellectual property right, including
          without limitation copyright, patent or trademark of any third party;
        </li>
        <li>
          The Comments do not contain any defamatory, libelous, offensive,
          indecent or otherwise unlawful material which is an invasion of
          privacy
        </li>
        <li>
          The Comments will not be used to solicit or promote business or custom
          or present commercial activities or unlawful activity.
        </li>
      </ul>

      <p>
        You hereby grant Artist Hub Inc. a non-exclusive license to use,
        reproduce, edit and authorize others to use, reproduce and edit any of
        your Comments in any and all forms, formats or media.
      </p>

      <h2>Hyperlinking to Our Content</h2>
      <p>At ArtistHub, we understand the importance of fostering a connected online community. We are pleased to permit any entity, including businesses, organizations, and individuals, to link to our website. Whether you're a fan, a partner, or a media outlet, we welcome and encourage you to create hyperlinks to our homepage, marketing pages, or any public content.</p>
      
      <p>When hyperlinking to our content, we ask that you:</p>
      <ul>
        <li>Ensure that the hyperlink is not misleading and does not falsely imply an endorsement, partnership, or affiliation with ArtistHub unless one has been explicitly established.</li>
        <li>Maintain the integrity of our content, ensuring that it does not appear in a context that could be considered offensive, controversial, or illegal.</li>
        <li>Preserve the high regard of our services and respect the work of our artists and contributors.</li>
      </ul>
      
      <p>You do not need to seek approval to link to ArtistHub; however, we reserve the right to request the removal of any link that we find inappropriate or inconsistent with our brand's values. In the spirit of openness, we do not restrict the use of our corporate name or web address for linking purposes. Nevertheless, the use of our logo or proprietary graphics is not permitted without a trademark license agreement.</p>
      
      <p>By linking to us, you agree to adhere to our hyperlinking terms and conditions. Thank you for your support and for being part of the ArtistHub community.</p>


      <h2>Content Liability</h2>

      <p>
        We shall not be hold responsible for any content that appears on your
        Website. You agree to protect and defend us against all claims that is
        rising on your Website. No link(s) should appear on any Website that may
        be interpreted as libelous, obscene or criminal, or which infringes,
        otherwise violates, or advocates the infringement or other violation of,
        any third party rights.
      </p>

      <h2>Reservation of Rights</h2>

      <p>
        We reserve the right to request that you remove all links or any
        particular link to our Website. You approve to immediately remove all
        links to our Website upon request. We also reserve the right to amen
        these terms and conditions and it’s linking policy at any time. By
        continuously linking to our Website, you agree to be bound to and follow
        these linking terms and conditions.
      </p>

      <h2>Restrictions on Use</h2>
      <p>
        You acknowledge and agree that the ArtistHub software and any
        accompanying documentation and/or technical information are proprietary
        and confidential to Artist Hub Inc. and its licensors and are protected
        by applicable intellectual property and other laws, including but not
        limited to copyright and trade secret laws. You agree that you will not,
        directly or indirectly, reverse engineer, decompile, disassemble, or
        otherwise attempt to discover the source code, object code, or
        underlying structure, ideas, or algorithms of the software or any
        documentation or data related to the software, or modify, translate, or
        create derivative works based on the software. You further agree not to
        use the software for any purposes beyond the scope of the license
        granted hereunder, including but not limited to the development of a
        competitive product or service. Any violation of this section shall be
        deemed a material breach of this Agreement and may result in the
        immediate termination of this Agreement.
      </p>

      <h2>Marketing Communications</h2>
      <p>By creating an account on ArtistHub, you agree that ArtistHub Inc. may send you promotional messages and materials from time to time via email. These materials may include but are not limited to, information about upgrades, new products or services, promotions, and other marketing material. If you do not wish to receive such marketing materials, you are given the option to unsubscribe from the mailing list at any time via the unsubscribe link provided in the email.</p>

      <h2>Liquidated Damages</h2>
      <p>In the event of a breach of this Agreement by you, you agree to pay ArtistHub liquidated damages in the amount of $89,000, or as otherwise specified in this Agreement. You acknowledge and agree that this amount represents a reasonable estimate of the damages that would be incurred by you due to such a breach and is not a penalty.</p>

      <h2>Removal of links from our website</h2>

      <p>
        If you find any link on our Website that is offensive for any reason,
        you are free to contact and inform us any moment. We will consider
        requests to remove links but we are not obligated to or so or to respond
        to you directly.
      </p>

      <p>
        We do not ensure that the information on this website is correct, we do
        not warrant its completeness or accuracy; nor do we promise to ensure
        that the website remains available or that the material on the website
        is kept up to date.
      </p>

      <h2>Jurisdiction and Venue; Attorneys Fees</h2>
      
      <p>All claims, disputes, or disagreement which may arise out of the interpretation, performance or breach of these Terms shall be submitted to the jurisdiction of the state courts of the State of Florida or the Federal District courts located in Palm Beach County.  You hereby submit to the personal jurisdiction of the courts in Palm Beach County. The prevailing party shall be entitled to recover reasonable attorneys’ fees, expenses and costs incurred by any of them in enforcing the terms of this Agreement, including appeals. In addition to other remedies available at all, ArtistHub shall have the right to equitable remedies including, without limitation, injunctive relief, to enforce its rights hereunder, without the requirement of having to post a bond or other surety in respect thereof.</p>

      <h2>Disclaimer</h2>

      <p>
        To the maximum extent permitted by applicable law, we exclude all
        representations, warranties and conditions relating to our website and
        the use of this website. Nothing in this disclaimer will:
      </p>

      <ul>
        <li>
          limit or exclude our or your liability for death or personal injury;
        </li>
        <li>
          limit or exclude our or your liability for fraud or fraudulent
          misrepresentation;
        </li>
        <li>
          limit any of our or your liabilities in any way that is not permitted
          under applicable law; or
        </li>
        <li>
          exclude any of our or your liabilities that may not be excluded under
          applicable law.
        </li>
      </ul>

      <p>
        The limitations and prohibitions of liability set in this Section and
        elsewhere in this disclaimer: (a) are subject to the preceding
        paragraph; and (b) govern all liabilities arising under the disclaimer,
        including liabilities arising in contract, in tort and for breach of
        statutory duty.
      </p>

      <p>
        As long as the website and the information and services on the website
        are provided free of charge, we will not be liable for any loss or
        damage of any nature.
      </p>
    </div>
  </div>
</template>
<script>
export default {};
</script>
